import { Injectable, signal } from '@angular/core';
import { StorageService } from 'core-tsi';

@Injectable({
  providedIn: 'root'
})

export class ThemeService {
  
  $theme = signal<string>('light')
  
  constructor() {
    this.loadTheme();
  }

  loadTheme() {
    const temaStorage = localStorage.getItem(StorageService.TEMA_APP) || 'light'
    this.setTheme(temaStorage)
  }

  setTheme(theme: string) {
    this.$theme.set(theme);
    localStorage.setItem(StorageService.TEMA_APP, theme);

    // Remove all theme classes
    document.body.classList.remove('dark-mode', 'sky-blue-mode', 'high-contrast-green-mode', 'purple-mode');

    // Apply the selected theme class
    if (theme !== 'light') {
      document.body.classList.add(`${theme}-mode`);
    }
  }

  // Keep toggle for backward compatibility if needed, but prefer setTheme
  toggle(isDark: boolean) {
    this.setTheme(isDark ? 'dark' : 'light');
  }

  // Helper for components to check if dark mode
  isDarkMode() {
    return this.$theme() === 'dark';
  }
}
